import { createContext } from "react";
const validTones = ["neutral", "secondary"];
const AccordionContext = createContext(
  null
);
export {
  AccordionContext,
  validTones
};
